import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function FA_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <FA_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <FA_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function FA_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What qualifications do I need to start a career in finance?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            ATo enter finance, most professionals have at least a bachelor's
            degree in finance, economics, accounting, or a related field.
            Certifications like CFA (Chartered Financial Analyst), CPA
            (Certified Public Accountant), or MBA in finance can be valuable for
            career advancement.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are the different career paths in finance?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Finance offers diverse career paths, including investment banking,
            corporate finance, financial planning, asset management, risk
            management, and accounting. Each path requires different skills and
            has varying responsibilities.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What skills are important for a successful finance career?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Analytical skills, proficiency in financial modeling, attention to
            detail, and strong mathematical abilities are essential. Soft skills
            like communication, problem-solving, and leadership also play a
            critical role.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How do I get a job in finance with no experience?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Entry-level positions often require internships or relevant academic
            projects. Networking, attending finance-related seminars, gaining
            knowledge in finance software, and obtaining certifications can also
            help you break into the industry.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are the highest-paying jobs in finance?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            The highest-paying roles typically include investment bankers, hedge
            fund managers, financial analysts, and private equity professionals.
            Positions in risk management and corporate finance at the executive
            level also offer high salaries.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
export default FA_FAQ_page
